// A BARRA DE ROLAGEM SÓ APARECE ENQUANTO ALGO ROLA, como a do macOS por padrão. Com a
// barra que ocupa espaço (Windows, ou o macOS com "mostrar sempre") ela ficava pintada
// em toda coluna do chat, mesmo parada. O CSS (`app.scss`) a deixa transparente e só a
// pinta no elemento marcado com o atributo abaixo, e quem marca é este ouvinte: a
// rolagem não tem seletor de CSS, então alguém precisa dizer quando ela está acontecendo.
//
// UM OUVINTE SÓ, no documento e na fase de captura: o evento de rolagem não sobe pela
// árvore, mas desce por ela, então a captura vê a rolagem de qualquer elemento - a coluna,
// a lista de um select, o modal - sem cada componente precisar se inscrever.
//
// Um ATRIBUTO e não uma classe: o Vue reescreve o `class` de um elemento a cada
// atualização e levaria a marca junto, mas não toca num atributo que ele não declarou.
const ATTRIBUTE = 'data-credere-scrolling';

// Quanto a barra fica depois do último movimento: o bastante para quem rolou ver onde
// parou, e curto para ela não ficar pintada como antes.
const DELAY_IN_MS = 800;

const timers = new WeakMap();

let installed = false;

function settle(element) {
  element.removeAttribute(ATTRIBUTE);
  timers.delete(element);
}

function scrolled(event) {
  const element = event.target;

  // Só o que é do widget: inline no web, o documento é do host, e os roladores dele não
  // são assunto daqui.
  if (!(element instanceof Element) || !element.closest('.credere-app')) {
    return;
  }

  if (!element.hasAttribute(ATTRIBUTE)) {
    element.setAttribute(ATTRIBUTE, '');
  }

  clearTimeout(timers.get(element));
  timers.set(element, setTimeout(settle, DELAY_IN_MS, element));
}

export default function scrolling() {
  if (installed) {
    return;
  }

  installed = true;

  document.addEventListener('scroll', scrolled, { capture: true, passive: true });
}
